import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import masterBrandActions from '../actions/masterBrand';
import actions from '../actions/actions';

const setStateInResp = (state, parsedResponse) => {
    if (state.companyLocation && !(parsedResponse.companyCountryCode && parsedResponse.countryList)) {
        parsedResponse.companyCountryCode = state.companyLocation.companyCountryCode;
        parsedResponse.countryList = state.companyLocation.countryList;
    }
};

function getMasterBrandData(store) {
    request.get(`/${config.url_prefix}/api/getMasterBrandData?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(masterBrandActions.alertError('internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.code >= 400 || parsedResponse.statusCode >= 400) {
                        store.dispatch(masterBrandActions.alertError('ipmob.error.process.request'));
                    } else {
                        setStateInResp(store.getState(), parsedResponse);
                        store.dispatch(masterBrandActions.getMasterBrandSuccess(parsedResponse));
                    }
                } catch (exp) {
                    store.dispatch(masterBrandActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}
export default getMasterBrandData;
